/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

export const onClientEntry = () => {
  require("@webteam/layout/lib/webpack-autoload");
  require("./src/styles/theme.pcss");
};

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  const { location: oldLocation } = prevRouterProps || {};
  const { location } = routerProps;

  // Not move scroll for popups inside one part
  return !["/talks/"].some(
    part =>
      oldLocation?.pathname?.indexOf(part) === 0 &&
      location?.pathname?.indexOf(part) === 0
  );
};
